import { ChatSession } from '../../../chat/models/ChatSession';
import { RootState } from '../../../../redux/store';
import { selectChatSessionsById } from '../../base/chat/selectChatSessionsById';
import { selectSelectedSessionId } from '../../base/chat/selectSelectedSessionId';

// This selector should resolve the currently selected ChatSession domain model.
//
// Intended usage:
// - used by feature hooks and higher-level selectors/view models
// - provides canonical session data such as id and providerType
// - handlers/hook code may use the selected session id to build commands and provider-aware operations
export const selectSelectedSession = (state: RootState): ChatSession | null => {
    const sessionId = selectSelectedSessionId(state);
    if (!sessionId) return null;

    const sessionsById = selectChatSessionsById(state);
    return sessionsById[sessionId] ?? null;
};
